import dayjs, { Dayjs } from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';

import { getTime } from 'date-fns';

dayjs.extend(relativeTime);

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'DD/MM/BBBB';

  if (!date) {
    return '';
  }

  return dayjs(new Date(date)).format(fm);
}

export function fTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'HH:mm A';

  if (!date) {
    return '';
  }

  return dayjs(new Date(date)).format(fm);
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'DD/MM/BBBB HH:mm';

  if (!date) {
    return '';
  }

  return dayjs(new Date(date)).format(fm);
}

export function isBetween(inputDate: Date | string | number, startDate: Date, endDate: Date) {
  const date = new Date(inputDate);

  const results =
    new Date(date.toDateString()) >= new Date(startDate.toDateString()) &&
    new Date(date.toDateString()) <= new Date(endDate.toDateString());

  return results;
}

export function isAfter(startDate?: Date | null, endDate?: Date | null) {
  const results =
    startDate && endDate ? new Date(startDate).getTime() > new Date(endDate).getTime() : false;

  return results;
}

export function shortDateLabel(startDate: Dayjs | null, endDate: Dayjs | null) {
  const getCurrentYear = new Date().getFullYear();

  const startDateYear = startDate ? startDate.get('year') : null;

  const endDateYear = endDate ? endDate.get('year') : null;

  const currentYear = getCurrentYear === startDateYear && getCurrentYear === endDateYear;

  const sameDay = startDate && endDate ? startDate.isSame(endDate, 'day') : false;

  const sameMonth = startDate && endDate ? startDate.isSame(endDate, 'month') : false;

  if (currentYear) {
    if (sameMonth) {
      if (sameDay) {
        return endDate?.format('DD MMM BBBB');
      }
      return `${startDate?.format('DD')} - ${endDate?.format('DD MMM BBBB')}`;
    }
    return `${startDate?.format('DD MMM')} - ${endDate?.format('DD MMM BBBB')}`;
  }

  return `${startDate?.format('DD MMM BBBB')} - ${endDate?.format('DD MMM BBBB')}`;
}

export function fToNow(date: InputValue) {
  return date ? dayjs(date).fromNow() : '';
}

export function isTodayOrAfter(date: Date | null) {
  if (!date) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date.getTime() >= today.getTime();
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}
